import { invokeEdgeFunction } from './invokeEdgeFunction';

/** Custom field that holds the last Reverse Contact `data` payload. */
export const REVERSE_CONTACT_FIELD = 'reverse_contact';

export function hasReverseContactResult(
  customData: Record<string, unknown> | null | undefined,
): boolean {
  const value = customData?.[REVERSE_CONTACT_FIELD];
  if (typeof value === 'string') return value.trim().length > 0;
  return value != null && typeof value === 'object';
}

export type ReverseContactLookupResult = {
  found: boolean;
  name: string | null;
  updated: string[];
  photo_note: string | null;
  credits_consumed?: number | null;
};

/** Look up this subscriber's email and write name, nickname, LinkedIn, and photo. */
export function lookupSubscriberWithReverseContact(
  subscriberId: string,
): Promise<ReverseContactLookupResult> {
  return invokeEdgeFunction<ReverseContactLookupResult>('reverse-contact-lookup', {
    subscriber_id: subscriberId,
  });
}
